<template>
  <div class="myOrder">
    <div class="top">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="所有订单" name="first">
          <div class="sub-main">
            <OrderList
              v-if="listShow"
              :orderList="orderList"
              :page="page"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待付款（含货到付款）" name="second">
          <div class="sub-main">
            <OrderList
              v-if="listShow"
              :orderList="orderList"
              :page="page"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待发货" name="third">
          <div class="sub-main">
            <OrderList
              v-if="listShow"
              :orderList="orderList"
              :page="page"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待收货" name="fourth">
          <div class="sub-main">
            <OrderList
              v-if="listShow"
              :orderList="orderList"
              :page="page"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
        <el-tab-pane label="待评价|已完成" name="fifth">
          <div class="sub-main">
            <OrderList
              :orderList="orderList"
              :page="page"
              @isCancel="isCancel"
              @isDelete="isDelete"
              @isConfirm="isConfirm"
              @isRefund="isRefund"
              @handleCurrentChange="handleCurrentChange"
            ></OrderList>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="search">
        <el-input
          placeholder="订单号"
          v-model="keyword"
          class="input-with-select"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="searchOrder"
          ></el-button>
        </el-input>
      </div>
      <el-dialog
        class="cancelOrder"
        :visible.sync="cancelOrderShow"
        close-on-click-modal
        :before-close="handleClose1"
        width="50%"
        title="是否取消该订单"
        center
      >
        <div>
          <p>您确定要取消该订单吗？取消订单后，不能恢复。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="cancelOrder" v-throttle
            >确定</el-button
          >
          <el-button class="rightBtn" @click="handleClose1">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="cancelOrder"
        :visible.sync="deleteOrderShow"
        close-on-click-modal
        :before-close="handleClose3"
        width="50%"
        title="是否删除该订单"
        center
      >
        <div>
          <p>您确定要删除该订单吗？删除订单后，不能恢复。</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="deleteOrder" v-throttle
            >确定</el-button
          >
          <el-button class="rightBtn" @click="handleClose3">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="confirm"
        :visible.sync="confirmShow"
        close-on-click-modal
        :before-close="handleClose2"
        width="60%"
        title="是否确认收货"
        center
      >
        <div>
          <p>为了保证您的售后权益，请收到商品检查无误后再确认收货</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="confirm" v-throttle
            >确定</el-button
          >
          <el-button class="rightBtn" @click="handleClose2">取消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="refund"
        :visible.sync="refund"
        width="50%"
        :before-close="handleClose"
        title="请选择售后商品"
        center
      >
        <div>
          <div class="mar-bot-20 fs18">
            <el-checkbox @change="changeBox" v-model="checked"
              >全选</el-checkbox
            >
          </div>
          <div class="box">
            <div
              class="back cur-poi"
              :class="
                productIds.indexOf(item.productId) != -1 ? 'backActive' : ''
              "
              @click="select(item.productId)"
              v-for="(item, index) in backList"
              :key="index"
            >
              <img class="mar-bot-10" :src="item.productInfo.image" alt="" />
              <p style="text-align: left" class="mar-bot-10 fs14">
                {{ item.productInfo.storeName }}
              </p>
              <div class="mar-bot-10 fs14 font-color-999">
                <span v-for="(val, inx) in item.attrInfo" :key="inx">{{
                  val
                }}</span>
              </div>
              <p class="mar-bot-20 fs14 font-color-999">x{{ item.cartNum }}</p>
              <p class="fs18 font-color-FF7">¥{{ item.truePrice }}</p>
              <img
                class="choice"
                src="../../../../static/image/bianjiao2@2x.png"
                alt=""
              />
            </div>

          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="leftBtn" @click="toAfterSale" v-throttle
            >确定</el-button
          >
          <el-button class="rightBtn" @click="handleClose">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import api from "../../../api";
import { listSearchMixin } from "../../../config/mixin";
import OrderList from "../../../components/base/orderList";
export default {
  mixins: [listSearchMixin],
  components: {
    OrderList,
  },
  name: "myOrder",
  data() {
    return {
      orderList: [],
      page: 1,
      limit:5,
      activeName: "first",
      keyword: "",
      state: "",
      cancelOrderShow: false,
      refund: false,
      index: null,
      cancelId: null,
      confirmId: null,
      confirmShow: false,
      deleteId: null,
      deleteOrderShow: false,
      listShow: false,
      checked: false,
      orderData: {},
      backList: [],
      productIds: [],
      productData: [],
      refundOptions:[],
      refundReason:"",
      refundReasonDetail:"",
	  orderType: ''
    };
  },
  mounted() {
    this.getOrderList();
    this.getRefundOrder();
  },
  methods: {
    //获取退款原因
    getRefundOrder(){
        let paramsMenu = {
                url: api.refundOrder,
                method: "GET",
              };
              this.sendReq(paramsMenu, (res) => {

                  var refundOption =[];
                  let i =0;
                  for (const key in res.data) {
                      let dataChild ={
                        value:key,
                        label:res.data[key]
                      }
                      refundOption.push(dataChild);
                  }
                  console.log(refundOption);
                    this.refundOptions=refundOption;
              });
    },
    // 获取订单列表
    getOrderList() {
      const rLoading = this.openLoading();
      let self = this;

      let params = {
        url:
          api.getOrderListPage +
          `?search=${self.keyword}&type=${self.orderType}&page=${self.page}&limit=5`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
         if (res.status ==200) {
              console.log(res.data)
            self.orderList = res.data
            self.listShow = true


            rLoading.close()
          } else {
                self.$message({
                    message: res.message,
                    type: 'warning'
                })
            }
        })
    },
    // 搜索订单
    searchOrder() {
      // this.activeName = "first";
      this.state = "";
      this.page = 1;
      this.getOrderList();
    },
    // 取消订单
    cancelOrder() {
      let self = this;
      let params = {
        url: api.cancelOrder,
        method: "POST",
        data: {
			id: self.cancelId,
          // orderId: self.cancelId,
        },
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: "订单取消成功",
            type: "success",
          });
          self.cancelOrderShow = false;
          self.getOrderList();
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 删除订单
    deleteOrder() {
      let self = this;
      let params = {
        url: api.deleteOrder,
        method: "DELETE",
        data: {
          orderId: self.deleteId,
        },
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: "订单删除成功",
            type: "success",
          });
          self.deleteOrderShow = false;
          self.getOrderList();
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 确认收货
    confirm() {
      let self = this;
      let params = {
        url: api.take,
        method: "post",
        data: {
          uni: self.confirmId,
        },
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.$message({
            message: "确认收货成功",
            type: "success",
          });
          self.confirmShow = false;
          self.getOrderList();
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 打开确认收货弹窗
    isConfirm(id) {
      this.confirmId = id;
      this.confirmShow = true;
    },
    // 打开删除订单弹窗
    isDelete(id) {
      this.deleteOrderShow = true;
      this.deleteId = id;
      // console.log(id)
    },
    // 切换订单列表
    handleClick(event) {
		this.orderType = event.index == 0 ? '' : +event.index - 1
		console.log(this.orderType)
      if (event.index === "0") {
        this.state = "";
      } else {
        this.state = event.index;
      }
      this.keyword = "";
      this.page = 1;
      this.getOrderList();
    },
    // 打开取消订单弹窗
    isCancel(id) {
      this.cancelOrderShow = true;
      this.cancelId = id;
    },
    // 关闭退货弹窗
    handleClose() {
      this.backList = [];
      this.checked = false;
      this.productIds = [];
      this.refund = false;
    },
    // 关闭删除订单弹窗
    handleClose3() {
      this.deleteOrderShow = false;
      this.deleteId = null;
    },
    // 关闭取消订单弹窗
    handleClose1() {
      this.cancelOrderShow = false;
      this.cancelId = null;
    },
    // 关闭确认收货弹窗
    handleClose2() {
      this.confirmShow = false;
      this.confirmId = null;
    },
    // 打开退货弹窗
    isRefund(data) {
      this.orderData = data;
      console.log("退款：",data);
      this.backList = data.cartInfo;
      this.refund = true;
    },
    // 选择退货商品
    select(id) {
		console.log(id)
      if (this.productIds.indexOf(id) === -1) {
        this.productIds.push(id);
      } else {
        this.productIds.splice(this.productIds.indexOf(id), 1);
      }
      if (this.productIds.length === this.backList.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    changeBox(val) {
			this.backList.forEach(item => {
				this.select(item.productId)
			})
      // if (val) {
      //   this.productIds = [];
      //   this.backList.map((item) => {
      //     this.productIds.push(item.productId);
      //   });
      //   // console.log(this.productIds)
      // } else {
      //   this.productIds = [];
      // }
    },
    // 跳转到申请售后页面
    toAfterSale() {
      if (this.productIds.length === 0) {
        this.$message({
          message: "请先选择需要申请售后的商品",
          type: "warning",
        });
        return;
      }
      var productData = [];
      for (var k in this.productIds) {
        for (var i in this.orderData.skus) {
          if (this.orderData.skus[i].productId === this.productIds[k]) {
            productData.push(this.orderData.skus[i]);
          }
        }
      }
      var paramsData = this.orderData;
      paramsData.skus = productData;
      this.$router.push({
        path: "/afterSale",
        query: {
          orderData: JSON.stringify(paramsData),
          state: 1,
        },
      });
    },
    // 分页器跳转
    handleCurrentChange(val) {
      this.page = val;
      this.getOrderList();
    },
  },
};
</script>
<style lang="scss" scoped>
.myOrder {
  width: 100%;
  background-color: #FFFFFF;
  .top {
    width: 100%;
    font-size: 14px;
    box-sizing: border-box;
    position: relative;
    >>> .el-tabs {
      .el-tabs__header {
        border: 1px solid #e5e5e5;
        //margin-bottom: 30px;
        height: 56px;
      }
      .el-tabs__nav {
        margin-left: 20px;
        height: 56px;
      }
      .el-tabs__item {
        height: 56px;
        line-height: 56px;
      }
      .el-tabs__nav-wrap::after {
        height: 0;
      }
    }
    >>> .search {
      font-size: 12px;
      margin-right: 20px;
      display: flex;
      position: absolute;
      height: 56px;
      display: flex;
      align-items: center;
      top: 0;
      right: 0;
      .el-input {
        flex: 3;
        border-radius: 0;
        .el-input__inner {
          border-radius: 0;
        }
        .el-input-group__append {
          border-radius: 0;
          border-left: 0;
          .el-button {
            border-left: 0;
          }
        }
      }
      .el-select {
        flex: 1;
        border-radius: 0;
        height: 40px;
      }
    }
  }
  >>> .cancelOrder,
  .confirm {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      div {
        text-align: center;
        p {
          font-size: 16px;
        }
      }
    }
    .el-dialog__footer {
      .leftBtn {
        background-color: #ff7800;
        border: 1px solid #ff7800;
        color: #ffffff;
        border-radius: 0;
      }
      .rightBtn {
        color: #ff7800;
        border: 1px solid #ff7800;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 0;
      }
    }
  }
  >>> .refund {
    .el-dialog__body {
      display: flex;
      justify-content: center;
      background-color: #f8f8f8;
      padding: 20px 75px;
      box-sizing: border-box;
      .box {
        display: flex;
        flex-wrap: wrap;
        overflow-x: auto;
        height: 350px;
        width: 100%;
        text-align: center;
      }
      .el-checkbox {
        display: flex;
        align-items: center;
      }
      .el-checkbox__input {
        line-height: 18px;
      }
      .el-checkbox__label {
        font-size: 18px;
      }
      .back {
        width: 208px;
        padding: 10px 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        text-align: center;
        flex-direction: column;
        background-color: #ffffff;
        margin: 0 20px 20px 0;
        border: 1px solid transparent;
        position: relative;
        img {
          width: 171px;
          height: 171px;
        }
        .choice {
          width: 30px;
          height: 30px;
          position: absolute;
          bottom: 0;
          right: 0;
          display: none;
        }
      }
      .back:nth-of-type(3n) {
        margin-right: 0;
      }
      .backActive {
        border: 1px solid #ff7800;
        .choice {
          display: block;
        }
      }
    }
    .el-dialog__footer {
      .leftBtn {
        background-color: #ff7800;
        border: 1px solid #ff7800;
        color: #ffffff;
        border-radius: 0;
      }
      .rightBtn {
        color: #ff7800;
        border: 1px solid #ff7800;
        background-color: #ffffff;
        box-sizing: border-box;
        border-radius: 0;
      }
    }
  }
}
.sub-main {
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/myOrder/myOrder.vue